
import { Component, Vue } from 'vue-property-decorator'
import NotifyUserService from '@/biz/service/Notify/NotifyUserService'

@Component
export default class ViewOtherWeChatNotifyUserIndex extends Vue {
  private Service = NotifyUserService
}
